// Difficulty configuration presets
export const DIFFICULTY_CONFIG = {
    easy: {
        name: "Easy Peasy",
        description: "For new adventurers",
        playerHealth: 150,
        damageMultiplier: 0.7,
        bossSpeedMultiplier: 0.8,
        telegraphBonus: 0.3,  // Extra telegraph time (seconds)
        minionSpawnMultiplier: 0.5  // Fewer minions
    },
    normal: {
        name: "Just Right",
        description: "Balanced challenge",
        playerHealth: 100,
        damageMultiplier: 1.0,
        bossSpeedMultiplier: 1.0,
        telegraphBonus: 0,
        minionSpawnMultiplier: 1.0
    },
    hard: {
        name: "Hero Mode",
        description: "For brave warriors",
        playerHealth: 75,
        damageMultiplier: 1.3,
        bossSpeedMultiplier: 1.2,
        telegraphBonus: -0.1,  // Less warning time
        minionSpawnMultiplier: 1.5  // More minions
    }
};

// Get difficulty setting with applied modifiers
export function getDifficultyModifier(difficulty, setting) {
    const config = DIFFICULTY_CONFIG[difficulty] || DIFFICULTY_CONFIG.normal;
    return config[setting];
}

// Apply difficulty to boss config
export function applyDifficultyToBoss(bossConfig, difficulty) {
    const diffConfig = DIFFICULTY_CONFIG[difficulty] || DIFFICULTY_CONFIG.normal;
    return {
        ...bossConfig,
        bossSpeed: bossConfig.bossSpeed * diffConfig.bossSpeedMultiplier,
        bossDamage: Math.round(bossConfig.bossDamage * diffConfig.damageMultiplier),
        telegraphTime: bossConfig.telegraphTime + diffConfig.telegraphBonus
    };
}

// Apply difficulty to player
export function applyDifficultyToPlayer(baseHealth, difficulty) {
    const diffConfig = DIFFICULTY_CONFIG[difficulty] || DIFFICULTY_CONFIG.normal;
    return diffConfig.playerHealth;
}
